import { render } from "./RichTextRender.vue?vue&type=template&id=3ecda03b"
import script from "./RichTextRender.vue?vue&type=script&lang=ts"
export * from "./RichTextRender.vue?vue&type=script&lang=ts"

import "./RichTextRender.vue?vue&type=style&index=0&id=3ecda03b&lang=postcss"
script.render = render

export default script